module.exports = __webpack_public_path__ + "media/images/pc/stores/shinjuku/shinjuku_concept_03-6059c409b01d756ed20c0a0ad010a0bb.jpg";